import { service } from '@ember/service';
import { task } from 'ember-concurrency';
import type StateService from 'garaje/services/state';

import ImporterService from './importer';

// Interface for the CSV data structure
interface ResourceCsvData {
  envoyId: string;
  name: string;
  floorName: string;
  amenities: string;
  assignedTo: string;
}

// Interface for the parsed props returned by _parseProps
interface ResourceProps {
  envoyId: string;
  name: string;
  floorName: string;
  amenities: string;
  assignedTo: string;
}

export default class ResourcesCsvImporterService extends ImporterService {
  @service declare state: StateService;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/require-await
  handleImport = task(async (data: ResourceCsvData): Promise<ResourceProps | null> => {
    const props = this._parseProps(data);
    return props;
  });

  private _parseProps(data: ResourceCsvData): ResourceProps {
    const { envoyId, name, floorName, assignedTo, amenities } = data;
    return {
      envoyId,
      name,
      floorName,
      assignedTo,
      amenities,
    };
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    resourcesCsvImporter: ResourcesCsvImporterService;
  }
}
